module.exports = __webpack_public_path__ + "static/img/img-educator-feature-2_ko.d1258c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-feature-2_ko.png
// module id = 59zC
// module chunks = 18